/**
* @file 公共组件-自定义表格
* */
<template>
  <div id="customTable">
    <!--顶部插槽-->
    <div class="customTable-top">
      <slot name="customTable-top"></slot>
    </div>

    <!--搜索部分-->
    <div class="custom-search">
      <custom-search
          :hasChannel="hasChannel"
          ref="customSearch"
          :has-organization="hasOrganization"
          :organization-default="organizationDefault"
          :search="customOptions.search"
          :labelWidth="labelWidth"
          :initSearch="initSearch"
          :organizationId="organizationId"
          :showLabel="customOptions.showLabel"
          :serchTipsRight="serchTipsRight"
          @resetFn="resetFn"
          @paramsFn="paramsFn"
      >
        <template slot="search-append">
          <slot name="deep-search-append"></slot>
        </template>
        <template slot="top-left">
          <slot name="search-top-left"></slot>
        </template>
        <template slot="top-right">
          <slot name="search-top-right"></slot>
        </template>
        <template slot="custom-search-button-left">
          <slot name="search-button-left"></slot>
        </template>
        <el-button
            v-if="addText"
            class="add-btn"
            type="primary"
            @click="addFn"
        >{{ addText }}
        </el-button
        >
        <el-button v-if="addTexts" :type="addTextsType" @click="addFns">{{
            addTexts
          }}
        </el-button>
        <slot name="search-button-right"></slot>
        <el-button v-if="this.btnPreFn(this.$route.name + '_import', false) && importExcel" @click="importFn"> 导入
        </el-button>
        <el-button v-if="excelType" @click="exportFn"> 导出</el-button>
        <el-button
            icon="el-icon-refresh"
            v-if="refreshShow"
            @click="refreshFn"
            style="margin-right: 10px"
        ></el-button>
        <el-popover
            v-model="settingDialog"
            placement="left-start"
            trigger="click"
            width="450"
            v-if="columnsSettingShow"
        >
          <div class="columns-filter">
            <div
                class="columns-filter-list"
                v-for="column in initColumns"
                :key="column.prop"
            >
              <el-checkbox
                  v-model="column.checked"
                  :label="column.checked"
                  :value="column.checked"
              >{{ column.label }}
              </el-checkbox
              >
            </div>
          </div>
          <div class="columns-footer">
            <el-button size="mini" @click="cancelColumns">取 消</el-button>
            <el-button size="mini" type="primary" @click="confirmColumns"
            >确 定
            </el-button
            >
          </div>
          <el-button slot="reference" icon="el-icon-setting"></el-button>
        </el-popover>
      </custom-search>
    </div>

    <slot name="search-bottom"></slot>

    <!--中间部分：列表-->
    <div class="custom-table">
      <!-- :style="{'max-height': maxHeight + 'px'}" -->
      <el-table
          ref="tableInner"
          v-loading="loading"
          v-loadmore="listFnPush"
          :height="maxHeight ? `${maxHeight}px` : '100%'"
          border
          stripe
          lazy
          fit
          highlight-current-row
          :columns="useColumns"
          :data="table.content"
          :key="toggleIndex"
          :empty-text="emptyText"
          :show-summary="summaryList.length > 0"
          :summary-method="getSummaries"
          :row-key="loadChildrenId"
          :load="loadChildren"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-click="onRowClick"
          @current-change="onCurrentChange"
          @expand-change="expandChangeFn"
          @select="onSelectFn"
          @selection-change="onSelectionChangeFn"
      >
        <!--复选框列-->
        <el-table-column
            fixed="left"
            type="selection"
            width="45"
            v-if="customOptions.selection"
            :selectable="selectEvent"
        ></el-table-column>
        <el-table-column
            v-if="
            (organizationHeader &&
              !organizationDefault &&
              hasOrganization &&
              mixinUserInfo &&
              mixinUserInfo.organizationType === 1) ||
            (showOrganization &&
              mixinUserInfo &&
              mixinUserInfo.organizationType === 1)
          "
            :show-overflow-tooltip="showOverflowTooltip"
            prop="organizationName"
            label="机构名称"
            width="150"
        >
        </el-table-column>

        <!--常规列数据-->
        <el-table-column
            v-for="(item, index) in useColumns"
            :key="index"
            :show-overflow-tooltip="showOverflowTooltip"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :min-width="item.minWidth"
            :width="item.width"
            :fixed="item.fixed"
            :align="item.align"
        >
          <template slot="header">
            <slot
                name="table-header"
                :prop="item.prop"
                :label="item.label"
            >{{ item.label }}</slot>
          </template>

          <template slot-scope="scope">
            <!--插槽：匿名插槽-->
            <slot :item="item" :row="scope.row"></slot>
          </template>
        </el-table-column>
        <slot name="table-channel"></slot>
        <!--插槽table-operation：列表操作项-->
        <slot name="table-operation"></slot>
      </el-table>
    </div>

    <!--底部部分：左侧插槽和右侧分页组件-->
    <div class="custom-footer">
      <div>
        <slot name="footer-left"></slot>
      </div>

      <el-pagination
          v-if="paging && !loadmoreSwitch"
          :current-page="params.page || 1"
          :page-size="params.size"
          :total="table.total"
          :page-sizes="[15, 20, 30, 40, 60]"
          @size-change="sizeChangeFn"
          @current-change="currentChangeFn"
          :layout="layout"
          :disabled="loading"
      />
    </div>

    <el-dialog
        class="dialog-export-modal"
        :visible.sync="exportState"
        title="导出数据"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
    >
      <el-checkbox
          v-model="item.isChecked"
          v-for="(item, index) in exportHeaders"
          :key="index"
          :disabled="item.disabled"
      >
        {{ item.title }}
      </el-checkbox>
      <template slot="footer">
        <el-button
            :loading="exportLoading"
            type="primary"
            @click="exportConfirmFn"
        >确定
        </el-button
        >
        <el-button @click="exportState = false">取消</el-button>
      </template>
    </el-dialog>

    <el-dialog
        class="dialog-export-modal"
        :visible.sync="importState"
        title=""
        width="1000px"
        v-if="importState"
        :close-on-click-modal="false"
    >
      <template slot="title">
        <span>批量导入</span>
        <el-button type="text" @click="downloadFn">下载模板</el-button>
        <div
            v-if="excelList && excelList.length > 0"
            style="position: relative; margin-left: 16px"
        >
          <el-button type="text" style="margin: 0" :loading="importImgLoading"
          >上传附件
          </el-button
          >
          <input
              style="
              opacity: 0;
              width: 50px;
              height: 28px;
              position: absolute;
              left: 0;
              top: 0;
            "
              type="file"
              accept=".png,.jpg,.jpeg"
              @change="changeInput"
              multiple="multiple"
          />
        </div>
        <el-button v-else type="text" @click="uploadImgClickFn"
        >上传附件
        </el-button
        >
      </template>
      <div
          style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <p class="util-remark">
            1.请先下载excel导入模版，每次最多导入60条数据
          </p>
          <p class="util-remark">
            2.批量选择附件图片，命名规则：{{ this.importDes }}
          </p>
          <p
              class="util-remark"
              v-for="(item, index) in importRemark"
              :key="index"
          >
            {{ index + 2 }}.{{ item }}
          </p>
        </div>
        <el-button
            type="primary"
            size="small"
            @click="confirmImport"
            :loading="importLoading"
        >导入数据
        </el-button
        >
      </div>
      <el-table
          border
          style="margin-top: 20px"
          :data="excelList"
          v-if="excelList && excelList.length > 0"
      >
        <el-table-column
            v-for="item in importColumns"
            :key="item.prop"
            :show-overflow-tooltip="showOverflowTooltip"
            max-height="200px"
            :width="item.width"
            :prop="item.prop"
        >
          <template slot="header">
            <span style="color: #f56c6c" v-if="item.required">*</span>
            {{ item.label }}
          </template>
          <template slot-scope="scope">
            <!--插槽：匿名插槽-->
            <slot name="importColumn" :item="item" :row="scope.row"></slot>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <div slot-scope="{ $index }" class="custom-action">
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click="removeClick($index)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
      <el-upload
          v-else
          class="upload-demo"
          accept=".xls,.xlsx"
          drag
          :on-change="handleChange"
          :auto-upload="false"
          :show-file-list="false"
          action="/api/v1/common/excel/read/import"
      >
        将导入模版拖至该区域或手动选择模版
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {mapGetters} from "vuex";

export default {
  name: "customTable",
  props: {
    /**
     * 配置项。具体配置项目如下：
     * url 必传项
     * listName 非必传
     * params 非必传
     * search 非必传，search参数说明, example:
     * search: {
     *    type: 'select', // 类型，必传
     *    field: 'status',// 字段，必传
     *    name: '小程序状态', // 字段名，必传
     *    value: '', // 字段值，非必传，设置值则表示该搜索项的默认选中值
     *    option: [], // select类型的下拉选择项，type为select时必传
     *    prop: { // 下拉选择项的自定义字段，默认是label,value,非必传
     *         label: 'label',
     *         value: 'status',
     *       }
     * }
     */
    // 滚动分页开关
    loadmoreSwitch: {
      default() {
        return false;
      },
    },
    customOptions: {
      default() {
        return {};
      },
    },
    emptyText: {
      default() {
        return "暂无数据";
      },
    },
    showOrganization: {
      default() {
        return false;
      },
    },
    hasChannel: {
      default() {
        return false;
      },
    },
    hasOrganization: {
      default() {
        return false;
      },
    },
    organizationId: {
      default() {
        return "";
      },
    },
    organizationDefault: {
      default() {
        return false;
      },
    },
    organizationHeader: {
      default() {
        return true;
      },
    },
    initSearch: {
      default() {
        return true;
      },
    },
    showOverflowTooltip: {
      default() {
        return true;
      },
    },
    /**
     * 表格配置
     */
    columns: {
      default() {
        return [];
      },
    },
    /**
     * 复选框选中的项
     */
    selectionRow: {
      default() {
        return [];
      },
    },
    /*复选框排他标识*/
    selectionNO: {
      default() {
        return null;
      },
    },
    /*复选框排他标识key*/
    selectionKey: {
      default() {
        return null;
      },
    },
    /**
     * 组合查询的label宽度
     */
    labelWidth: {
      default() {
        return 100;
      },
    },
    /**
     * 是否显示分页，默认显示
     */
    paging: {
      default() {
        return true;
      },
    },
    action: {
      // 上传的七牛云地址
      default() {
        let url = "http://up-z1.qiniu.com";
        if (window.location.protocol === "http:") {
          url = "http://up-z1.qiniu.com";
        } else if (window.location.protocol === "https:") {
          url = "https://upload-z1.qbox.me";
        }
        return url;
      },
    },
    /**
     * 是否显示分页，默认显示
     */
    layout: {
      default() {
        return "total, sizes, jumper, prev, pager, next";
      },
    },
    // 列表添加按钮
    addText: {
      default() {
        return "";
      },
    },
    // 列表添加按钮
    addTexts: {
      default() {
        return "";
      },
    },
    // 列表添加按钮
    addTextsType: {
      default() {
        return "primary";
      },
    },
    // 列表添加按钮
    excelType: {
      default() {
        return "";
      },
    },
    // 导入类型
    importExcel: {
      default() {
        return "";
      },
    },
    // 导入类型
    importRules: {
      default() {
        return [];
      },
    },
    importDes: {
      default() {
        return "";
      },
    },
    importRemark: {
      default() {
        return [];
      },
    },
    // 导入表头
    importColumns: {
      default() {
        return [];
      },
    },
    // 导入表头
    importRuleKey: {
      default() {
        return "phone";
      },
    },
    // 搜索右边提示
    serchTipsRight: {
      default() {
        return "";
      },
    },
    // 刷新按钮是否显示
    refreshShow: {
      default() {
        return true;
      },
    },
    // 刷新按钮是否显示
    columnsSettingShow: {
      default() {
        return false;
      },
    },
    // 表格最大高度
    maxHeight: {
      default() {
        return "";
      },
    },
    // 合计行
    summaryList: {
      default() {
        return [];
      },
    },
    // 异步加载子列表标识
    hasChildren: {
      type: String,
      default: "",
    },
    // 异步加载子列表id
    loadChildrenId: {
      type: String,
      default: "id",
    },
    // 异步加载子列表方法
    loadChildren: {
      type: Function,
      default() {
        return [];
      },
    },
    // 导出限制条件
    exportRequiredFields: {
      type: Array,
      default: () => [],
    },
    exportType: {
      type: Array,
      default: () => [],
    },
    hasChecked: {
      type: Boolean,
      default: false,
    },
    checkedList: {
      type: Array,
      default: () => [],
    },
  },

  directives: {
    loadmore: {
      bind(el, binding, vnode) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const sign = 1;
          const scrollDistance =
              this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= sign) {
            if (vnode.context.loadmoreSwitch) {
              binding.value();
            }
          }
        });
      },
    },
  },
  data() {
    return {
      toggleIndex: 0,
      importImgLoading: false,
      importLoading: false,
      excelList: [],
      importState: false,
      exportHeaders: [], // 导出弹框--导出表头
      exportState: false, // 导出弹框--true显示，false隐藏
      exportLoading: false, // 导出弹框--true显示，false隐藏
      // table数据
      table: {
        content: [],
        total: 0,
      },
      // 表格loading
      loading: false,
      // 构造后的搜索项
      params: {},
      // 中止复选框更新
      stopUpdate: false,
      // 选中的数据
      selectionList: [],
      settingDialog: false,
      filterColumns: [],
      initColumns: [],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfoGetter",
    }),
    useColumns() {
      return this.columnsSettingShow ? this.filterColumns : this.columns
    }
  },
  watch: {
    excelList: {
      handler(val) {
        if (val) {
          // let state = val.some(item => item.loading > 0)
          // this.importImgLoading = state
        }
      },
      deep: true,
      immediate: true,
    },
    "table.content": {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tableInner.doLayout();
        });
      },
      deep: true,
      immediate: true,
    },
    "$route.path": {
      handler(val) {
        this.initColumn(val, this.userInfo);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    cancelColumns() {
      this.initColumn(this.$route.path, this.userInfo);
      this.settingDialog = false;
    },

    async confirmColumns() {
      this.filterColumns = this.initColumns.filter((item) => item.checked);
      this.toggleIndex = Math.random();
      this.settingDialog = false;
      const data = {
        key: `${this.$route.path}${this.userInfo.id}`,
        value: this.initColumns,
      };
      if (window.indexedDB) {
        const db = await this.$IndexDB.openDB("sfx", "columns");
        const hasKeyData = await this.$IndexDB.getDataByKey(db, "columns", data.key);
        if (hasKeyData) {
          this.$IndexDB.updateDB(db, "columns", data);
        } else {
          this.$IndexDB.addData(db, "columns", data);
        }
      } else {
        sessionStorage.setItem(`${this.$route.path}${this.userInfo.id}`, JSON.stringify(this.initColumns));
      }
    },
    settingShow() {
      this.settingDialog = true;
    },
    // 初始化 给 选中和未选中赋值
    async initColumn(path, userInfo) {
      const db = await this.$IndexDB.openDB("sfx", "columns");
      const dbData = await this.$IndexDB.getDataByKey(db, "columns", `${path}${userInfo.id}`);
      if (window.indexedDB && dbData) {
        const storegeColumns = dbData.value;
        this.initColumns = this.columns.map((item) => {
          const item2 = storegeColumns.find((storegeItem) => item.prop == storegeItem.prop);
          return {
            ...item,
            checked: item2 ? item2.checked : !item.hide,
          };
        });
        this.filterColumns = this.initColumns.filter((item) => item.checked);
      } else if (sessionStorage.getItem(`${path}${userInfo.id}`)) {
        const storegeColumns = JSON.parse(sessionStorage.getItem(`${path}${userInfo.id}`));
        this.initColumns = this.columns.map((item) => {
          const item2 = storegeColumns.find((storegeItem) => item.prop == storegeItem.prop);
          return {
            ...item,
            checked: item2 ? item2.checked : !item.hide,
          };
        });
        this.filterColumns = this.initColumns.filter((item) => item.checked);
      } else {
        this.initColumns = this.columns.map((item) => {
          return {
            ...item,
            checked: !item.hide,
          };
        });
        this.filterColumns = this.initColumns.filter((item) => item.checked);
      }
    },

    // 合计行
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        let found = this.summaryList.find(function (item) {
          return item.name == column.property;
        });
        if (found) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = +curr;
              if (!isNaN(value)) {
                return new Decimal(prev).add(new Decimal(curr)).toNumber();
              } else {
                return prev;
              }
            }, 0);
            if (found.beforeUnit) {
              sums[index] = found.beforeUnit + sums[index].toFixed(2);
            }
          } else {
            sums[index] = "N/A";
          }
        }
      });
      this.$nextTick(() => {
        this.$refs["tableInner"].doLayout();
      });
      return sums;
    },
    removeClick(index) {
      this.excelList.splice(index, 1);
    },
    async confirmImport() {
      if (this.excelList && this.excelList.length > 0) {
        let state = this.excelList.some((item) => {
          let state = 0;
          this.importRules.forEach((i) => {
            if (item[i] === undefined || item[i] === "" || item[i] === null) {
              state++;
            }
          });
          if (state > 0) {
            return true;
          } else {
            return false;
          }
        });
        if (state) {
          this.$message.warning("请补全信息后再导入");
          return;
        }
      } else {
        this.$message.warning("请录入模版");
        return;
      }
      this.importLoading = true;
      let url = "/api/v1/common/excel/batch/import";
      let params = {
        excelType: this.excelType,
        excelList: JSON.stringify(this.excelList),
      };
      let data = await this.$axios.post(url, params);
      this.importLoading = false;
      if (data && data.code === 1) {
        this.listFn();
        this.importState = false;
      }
    },
    uploadImgClickFn() {
      this.$message.warning("请先上传模版");
    },
    async changeInput(e) {
      let files = e.target.files;
      if (files) {
        this.importImgLoading = true;
        let qiniuToken = await this.getQiniuTokenFn();
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          let name = file.name.split(".")[0];
          if (
              name &&
              name.split("-") &&
              name.split("-")[0] &&
              name.split("-")[1]
          ) {
            let lastName = name.split("-")[0];
            let item = this.importColumns.find(
                (item) => item.label === name.split("-")[1]
            );
            if (item) {
              let type = item.prop;
              let state = this.excelList.some(
                  (item) => item[this.importRuleKey] === lastName
              );
              if (state) {
                let formData = new FormData();
                formData.append("token", qiniuToken);
                formData.append("file", file);
                let data = await this.$axios.post(this.action, formData);
                if (data && data.hash) {
                  this.excelList.map((item) => {
                    if (item[this.importRuleKey] === lastName) {
                      item[type] = data.hash;
                    }
                    return item;
                  });
                } else {
                  this.$message.warning("上传失败，请稍后再试~");
                }
              }
            }
          }
        }
        this.importImgLoading = false;
      }
    },
    downloadFn() {
      window.open(this.importExcel);
    },
    /**
     * 待上传文件变化
     * @param val
     */
    handleChange(val) {
      if (!/\.(xls|xlsx)$/.test(val.name)) {
        this.$message.warning("只能导入.xls，.xlsx类型的文件", "warning");
        return false;
      }
      this.uploadFn(val);
    },
    /**
     * 上传阿里云
     * @param file 文件
     * @returns {Promise<boolean>}
     */
    async uploadFn(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("excelType", this.excelType);
      let data = await this.$axios.post(
          "/api/v1/common/excel/read/import",
          formData
      );
      if (data && data.code === 1 && data.data) {
        this.excelList = data.data;
      }
    },
    importFn() {
      if (!this.btnPreFn(this.$route.name + "_import")) {
        return;
      }
      this.excelList = [];
      this.importState = true;
    },
    async exportConfirmFn() {
      if (this.table.total === 0) {
        this.$message.warning("导出数据不能为空");
        return;
      }
      let header = [];
      this.exportHeaders.forEach((item) => {
        if (item.isChecked) {
          header.push(item.title);
        }
      });
      if (header.length < 1) {
        this.$message.warning("请选择导出表头");
        return;
      }
      if (this.exportRequiredFields.length) {
        if (this.exportType && this.exportType.length) {
          const findIndex = this.exportType.findIndex(
              (item) => this.params[item.start] && this.params[item.end]
          );
          if (findIndex == -1) {
            const findIndex2 = this.exportType.findIndex(
                (item) => !(this.params[item.start] && this.params[item.end])
            );
            this.$message.warning({
              message: this.exportType[findIndex2].text,
            });
            return;
          }
        } else {
          for (const field of this.exportRequiredFields) {
            if (!this.params[field.prop]) {
              this.$message.warning({message: field.text});
              return;
            }
          }
        }
      }
      this.exportLoading = true;
      let params = JSON.parse(JSON.stringify(this.params));
      params.excelType = this.excelType;
      params.header = header.join(",");
      delete params.page;
      delete params.size;
      let data = await this.$axios.get("/api/v1/common/excel", params);
      this.exportLoading = false;
      if (data && data.code === 1) {
        this.exportState = false;
        this.$store.dispatch("acExcelForm", data.data);
        this.$mqtt.newTopic({
          tpc: data.data.topic,
          opt: {
            qos: 1,
          },
        });
      }
    },
    async exportFn() {
      const notNeedPermissions = [
        "DriverFlowing",
        "VehicleFlowing",
        "SensitivePersonnelAlert",
        "OrderChartered",
        "CharteredFlowing",
        "BackupsDriver",
        "BackupsVehicle",
        "OrderIntercity",
        "OrderLine",
        "IntercityFlowing",
        "FinancialLine",
        "VehicleStationSettle",
        "StationBase",
        "SystemTicketStatistics",
        "MobileTicketStatistics",
        "ReferrerFlowing",
        "InspectStatistics",
        "AiRecord",
        "SmsBalanceRecord",
        "AiBalanceRecord",
        "FinanceFlowingHitchRide",
        "DriverInvitation",
        "HitchRideActivityRecord",
        "HitchRideOrderHistory",
        "HitchRideAdverseRecord",
        "OrganizationHitchRideBill",
        "OrganizationHitchRideBillDetail",
        "AirportFinanceFlowing",
        "AirportAccountFinanceFlowing",
        "TravelOrder",
        "TravelOrderDriver",
        "TravelGoodsOrder",
        "TravelFinanceFlowing",
        "ChannelList",
        "ChannelOrder",
        "ChannelFinance",
      ];
      if (!notNeedPermissions.includes(this.excelType)) {
        if (!this.btnPreFn(this.$route.name + "_export")) {
          return;
        }
      }
      let exportHeaders = [];
      this.exportState = true;
      let url = "/api/v1/common/excel/header";
      let params = {
        excelType: this.excelType,
        organizationId: this.params.organizationId || "",
      };

      let data = await this.$axios.get(url, params);
      const disabledList = [
        "VehicleStationSettle",
        "SystemTicketStatistics",
        "MobileTicketStatistics",
      ];
      if (data && data.code === 1 && data.data) {
        exportHeaders = data.data.split(",").map(
            (item) =>
                (item = {
                  isChecked: true,
                  title: item,
                  disabled: disabledList.includes(this.excelType),
                })
        );
      }
      this.exportHeaders = exportHeaders;
    },
    /* 监听重置 */
    resetFn() {
      this.$emit("resetFn");
    },
    /* 搜索参数 */
    paramsFn(params) {
      this.params = Object.assign(this.params, params);
      this.listFn();
    },
    /**
     * 当用户对某一行展开或者关闭的时候会触发该事件
     */
    expandChangeFn(row, expanded) {
      this.$emit("expandChangeFn", row, expanded);
    },

    /**
     * 单选
     */
    onCurrentChange(currentRow) {
      this.$emit("onCurrentChange", currentRow);
    },
    // 复选框禁用条件
    selectEvent(row) {
      if (this.selectionNO) {
        return row.selectionNO == this.selectionNO ? true : false;
      } else {
        return true;
      }
    },
    // 点击复选框事件
    onSelectFn(selection, row) {
      let index = this.table.content.findIndex((item) => {
        return item.id == row.id;
      });
      if (this.selectionRow.length >= 6 && selection.length > 6) {
        this.stopUpdate = true;
        setTimeout(() => {
          this.stopUpdate = false;
        }, 50);
        this.$refs.tableInner.toggleRowSelection(
            this.table.content[index],
            false
        );
        this.$message.warning("最多同时勾选6条订单");
      } else {
        this.table.content[index].checkStatus = true;
        this.$emit("update:selectionRow", selection);
        this.$emit("selection-change", selection);

      }
    },
    /**
     * 复选数据发生变化回调
     */
    onSelectionChangeFn(selection) {
      if (!this.stopUpdate) {
        if (this.selectionRow.length <= 6 && selection.length <= 6) {
          this.selectionList = selection.map((item) => {
            return item.id;
          });
          this.$emit("update:selectionRow", selection);
        }
      }
      this.$emit("selection-change", selection);
    },
    /* 当某一行被点击时会触发该事件 */
    onRowClick(row, column, event) {
      if (event.target.tagName == "INPUT") {
        return;
      }
      if (this.customOptions.selection) {
        if (
            this.selectionRow.length == 0 ||
            row.selectionNO == this.selectionNO
        ) {
          let index = this.table.content.findIndex((item) => {
            return item.id == row.id;
          });

          if (this.table.content[index].checkStatus) {
            this.table.content[index].checkStatus = false;
          } else {
            if (this.selectionRow.length == 6) {
              this.$message.warning("最多同时勾选6条订单");
              return;
            }
            this.table.content[index].checkStatus = true;
          }
          this.$refs.tableInner.toggleRowSelection(this.table.content[index]);

          this.$emit(
              "update:selectionRow",
              this.table.content.filter((item) => item.checkStatus)
          );

        }
      } else {
        this.$emit("onRowClick", row, column, event);
      }
    },
    /**
     * 页码改变的回调，返回改变后的页码
     */
    sizeChangeFn(val) {
      this.params.size = val;
      this.listFn();
    },
    /**
     * 切换每页条数时的回调，返回切换后的每页条数
     */
    currentChangeFn(val) {
      this.params.page = val;
      this.listFn();
    },
    /**
     * 外部调用方法-获取列表信息
     */
    getList() {
      this.listFn();
    },
    /**
     * 接口调用-获取列表信息
     */
    async listFn() {
      if (this.customOptions.firstNotRequest) {
        return;
      }
      console.log(this.params, 323232);
      Object.keys(this.params).forEach(key => {
        Array.isArray(this.params[key]) && this.params[key].length > 0 && delete this.params[key]
      })
      this.loading = true;
      let data;
      // 支持自定义函数获取数据
      if (this.customOptions.customFn && typeof this.customOptions.customFn === 'function') {
        data = await this.customOptions.customFn(this.params);
      } else {
        data = await this.$axios.get(this.customOptions.url, this.params);
      }

      if (this.selectionKey) {
        data.data.forEach((item) => {
          item.selectionNO = item[this.selectionKey];
        });
      }

      if (this.hasChildren) {
        data.data.forEach((item) => {
          item.hide = false;
          if (item[this.hasChildren] > 1) {
            item.hasChildren = true;
          }
        });
      }

      if (data) {
        if (this.customOptions.listName) {
          let arr = this.customOptions.listName.split(".");
          let content = data;
          arr.forEach((item) => {
            content = content[item];
          });
          this.table = {
            content: content || [],
            total: data.total || 0,
          };
        } else {
          if (this.params.page > 1 && data.data.length === 0) {
            this.currentChangeFn(this.params.page - 1)
            return;
          }
          if (this.hasChecked) {
            data.data.forEach((item) => {
              item.checked = this.checkedList.some(checkedItem => checkedItem.driverId === item.driverId)
            })
          }
          this.table = {
            content: data.data || [],
            total: data.total || 0,
          };
        }
        this.$emit("listBack", data.data, data);
      }
      this.loading = false;
      this.$emit("list", this.params);
    },
    /**
     * 接口调用-滚动分页获取列表信息
     */
    async listFnPush() {
      if (this.table.total <= this.params.page * this.params.size) {
        return;
      }
      let selectionList = this.selectionList;
      this.loading = true;
      this.params.page = this.params.page + 1;
      let data;
      // 支持自定义函数获取数据
      if (this.customOptions.customFn && typeof this.customOptions.customFn === 'function') {
        data = await this.customOptions.customFn(this.params);
      } else {
        data = await this.$axios.get(this.customOptions.url, this.params);
      }

      if (this.selectionKey) {
        data.data.forEach((item) => {
          item.selectionNO = item[this.selectionKey];
        });
      }

      if (this.hasChildren) {
        data.data.forEach((item) => {
          item.hide = false;
          if (item[this.hasChildren] > 1) {
            item.hasChildren = true;
          }
        });
      }

      if (data) {
        if (this.customOptions.listName) {
          let arr = this.customOptions.listName.split(".");
          let content = data;
          arr.forEach((item) => {
            content = content[item];
          });
          this.table = {
            content: this.table.content.concat(content) || [],
            total: data.total || 0,
          };
        } else {
          if (this.hasChecked) {
            data.data.forEach((item) => {
              item.checked = this.checkedList.some(checkedItem => checkedItem.driverId === item.driverId)
            })
          }
          this.table = {
            content: this.table.content.concat(data.data) || [],
            total: data.total || 0,
          };
        }
        this.$emit("listBack", this.table.content.concat(data.data));
      }
      this.loading = false;
      this.$emit("list");

      // 默认勾选上一页的选中复选框
      this.$nextTick(() => {
        if (this.customOptions.selection && selectionList.length > 0) {
          this.table.content.forEach((row) => {
            if (selectionList.indexOf(row.id) >= 0) {
              this.$refs.tableInner.toggleRowSelection(row, true);
            }
          });
        }
      });
    },

    /* 列表-添加 */
    addFn() {
      this.$emit("addFn");
    },
    /* 列表-添加 */
    addFns() {
      this.$emit("addFns");
    },
    /* 列表-刷新 */
    refreshFn() {
      this.params.page = 1;
      this.listFn();
      this.$emit("refreshFn");
    },
  },
  created() {
    // 构造初始参数
    this.params = this.customOptions.params || {};
    // 如果显示分页，判断是否传入了页码和条数，无则设置默认值
    if (this.paging) {
      this.params.size = this.params.size || 20;
    }
  },
  mounted() {
  },
};
</script>

<style lang="less">
#customTable {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  overflow: hidden;

  .customTable-top {
    flex-shrink: 0;
  }

  .custom-search {
    margin-bottom: 16px;
    flex-shrink: 0;
  }

  .custom-table {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  .custom-footer {
    flex-shrink: 0;
    margin-top: 12px;
    padding-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f0f0f0;

    .ivu-page {
      display: inline-block;
    }
  }

  .upload-demo {
    width: 100%;
    margin-top: 20px;

    .el-upload,
    .el-upload-dragger {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.dialog-export-modal {
  .el-dialog__header {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 16px;
    }
  }

  .el-checkbox {
    margin-right: 30px;
    margin-bottom: 10px;
  }
}

// popover 内部设置最高和滚动条
.columns-filter {
  width: 450px;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  position: relative;
  display: flex;
  flex-wrap: wrap;

  .columns-filter-list {
    width: 150px;
  }
}

.columns-footer {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-table__fixed-footer-wrapper tbody td.el-table__cell {
  background-color: #e4e4e4 !important;
}
</style>
